
import React, { useRef, useState } from "react";
import Avatar from "@mui/material/Avatar";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import toast from "react-hot-toast";
import Cropper from "react-easy-crop";
// import { getCroppedImg } from "./cropUtils"; // helper to crop image and convert to blob
const ImageUploader = ({ image, setImage, height = 250, apiImage = null }) => {
  const nationalId = useRef();
  const imageFileRegex = /\.(jpg|jpeg|png|gif|bmp)$/i;
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [cropping, setCropping] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!imageFileRegex.test(file.name)) {
        toast.error("Invalid image format");
        setImage(null); // Reset the image state to null if the file is not a valid image
      } else {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          setCroppedImage(reader.result);
          setCropping(true); // Start cropping once image is loaded
          setImage(apiImage);
        };
      }
    }
  };
  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };
  const handleCrop = async () => {
    try {
      const croppedBlob = await getCroppedImg(croppedImage, croppedAreaPixels);
      setImage(croppedBlob); // Set the cropped image as the final image
      setCropping(false); // Exit cropping mode
    } catch (error) {
      console.error("Failed to crop image", error);
    }
  };
  const CONTAINER_HEIGHT = 600


  return (
    <div>
      {cropping ? (
        <div>
          <div style={{ position: "relative", width: "100%", height: height }}>
            <Cropper
              image={croppedImage}
              crop={crop}
              zoom={zoom}
              aspect={4 / 3}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
              onMediaLoaded={(mediaSize) => {
                // Adapt zoom based on media size to fit max height
                setZoom(CONTAINER_HEIGHT / mediaSize.naturalHeight)
              }}
            />
          </div>
          <button className="btn_size" onClick={handleCrop}>
            Crop Image
          </button>
        </div>
      ) : (
        <div>
          {image ? (
            <Avatar
              onClick={() => nationalId.current.click()}
              variant="rounded"
              alt="uploaded image"
              src={
                typeof image === "string" && image.startsWith("http")
                  ? image
                  : URL.createObjectURL(image)
              }
              // src={image}
              role="button"
              sx={{
                height: height,
                width: "auto",
                borderRadius: 1,
                border: "1px solid #C86337",
              }}
            >
              <InsertPhotoIcon sx={{ fontSize: 60 }} />
            </Avatar>
          ) : (
            <div>
              <Avatar
                className="w-100"
                variant="rounded"
                onClick={() => nationalId.current.click()}
                src={image}
                sx={{
                  height: height,
                  cursor: "pointer",
                  border: "2px dotted #C86337",
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "#C86337",
                }}
              >
                <PermMediaIcon sx={{ fontSize: 100 }} />
                <div>
                  <p className="mt-2">Upload Resource Cover Image</p>
                  <p
                    style={{
                      fontSize: "12px",
                      marginTop: "10px",
                      textAlign: "center",
                    }}
                  >
                    Minimum 343px Width 185px Height. Max 10MB
                  </p>
                </div>
              </Avatar>
            </div>
          )}
          <input
            type="file"
            ref={nationalId}
            style={{ display: "none" }}
            onChange={handleImageUpload}
            accept="image/*"
          />
        </div>
      )}
    </div>
  );
};

export default ImageUploader;

export const getCroppedImg = (imageSrc, croppedAreaPixels) => {
  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.src = url;
    });

  return new Promise(async (resolve, reject) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    canvas.toBlob((blob) => {
      resolve(blob);
    }, "image/jpeg");
  });
};




